import React from 'react';
import Styled from 'styled';
import defaultStyles from './emphasized-text-view.scss';

@Styled(defaultStyles)
class EmphasizedTextView extends React.PureComponent {
    render() {
        const { text, styles, emphasize } = this.props;

        if (!emphasize) {
            return <span>{text}</span>;
        }

        const split = text.split(new RegExp(emphasize, 'i'));
        let string = text;

        const getChild = index => {
            const emphasized = string.substring(0, emphasize.length);
            string = string.slice(emphasize.length);

            return (
                <em key={`${emphasize}-${index}`} className={styles.emphasized}>
                    {emphasized}
                </em>
            );
        };

        return (
            <span>
                {split.map((part, index) => {
                    if (!part) {
                        return getChild(index);
                    } else if (index !== split.length - 1) {
                        string = string.slice(part.length);

                        return (
                            <span key={index.toString()}>
                                {part}
                                {getChild(index)}
                            </span>
                        );
                    }

                    return <span key={index.toString()}>{part}</span>;
                })}
            </span>
        );
    }
}

export default EmphasizedTextView;
